import { FFmpeg } from '@ffmpeg/ffmpeg';
import { SYNC_KEY } from '../constant';

export const getCroppedImg = (imageSrc, pixelCrop) => {
  const image = new Image();
  image.src = imageSrc;

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        console.error('Canvas is empty');
        return;
      }
      const croppedImageUrl = URL.createObjectURL(blob);
      resolve(croppedImageUrl);
    }, 'image/jpeg');
  });
};

const ffmpeg = new FFmpeg()

export const convertToMp3 = async (blobUrl) => {
  try {
    // Load FFmpeg core if not already loaded
    if (!ffmpeg.loaded) await ffmpeg.load();

    // Fetch the Blob from the blobUrl
    const response = await fetch(blobUrl);
    const webmBlob = await response.blob();

    // Write the input audio blob to FFmpeg's virtual file system
    await ffmpeg.writeFile("input.webm", await webmBlob.arrayBuffer());

    // Execute FFmpeg to convert the file to MP3
    await ffmpeg.exec(["-i", "input.webm", "output.mp3"]);

    // Read the output file and convert it to a Blob
    const mp3Data = await ffmpeg.readFile("output.mp3");
    return new Blob([mp3Data], { type: 'audio/mp3' });

  } catch (error) {
    console.error("Error during audio conversion:", error);
    throw error;
  }
};

export const getCroppedImgBlob = (imageSrc, crop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.crossOrigin = 'anonymous';

    image.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext('2d');
      if (!ctx) return reject(new Error('Failed to get canvas context'));

      ctx.drawImage(
        image,
        crop.x,
        crop.y,
        crop.width,
        crop.height,
        0,
        0,
        crop.width,
        crop.height
      );

      canvas.toBlob((blob) => {
        if (!blob) return reject(new Error('Canvas is empty'));
        resolve(blob);
      }, 'image/jpeg');
    };

    image.onerror = (err) => reject(err);
  });
};


export const blobToDataUrl = async (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob); // Converts Blob to base64 encoded URL
  });
};


export const getStoredSyncTimestamp = () => {
  try {
    return localStorage.getItem(SYNC_KEY);
  } catch {
    return null;
  }
};

export const saveSyncTimestamp = (ts) => {
  try {
    if (ts) localStorage.setItem(SYNC_KEY, ts);
  } catch { }
};

export const clearSyncTimestamp = async () => {
  try {
    localStorage.removeItem(SYNC_KEY)
  } catch { }
};